import { Controller } from "stimulus";

export default class extends Controller {
    static targets = ['adjustUrl']

    connect(){
        this.is_adjust = this.adjustUrlTarget.value === "true" ? true : false
        if(navigator.userAgent.toLowerCase().indexOf("android") > -1 && this.is_adjust){
            window.location.href = 'https://play.google.com/store/apps/details?id=dev.rnm.enjoyyit_public&referrer=adjust_reftag';
        }
        else if ((navigator.userAgent.toLowerCase().indexOf("iphone") > -1) && this.is_adjust) {
            window.location = `enjoyyit${this.application_type()}://`;
            setTimeout(function() {
              window.location = 'itms-apps://itunes.apple.com/us/app/enjoyyit-einfach-sparen/id1616303065'
            }, 250);
        } 
        this.open_partner();
    }

    open_partner(){
        if (window.webkit && window.webkit.messageHandlers) {
            webkit.messageHandlers.performAction.postMessage({
              action: "openPartner"
            });
        }
    }

    application_type(){
        switch (project_env) {
            case "development":
                return "-dev";
            case "qa":
                return "-qa";
            default:
                return "";
        }
    }
}
